import moment from 'moment';
import { decimalNumber, numeric } from 'Utils/validationUtils';

export function getLevelOneComponents() {
  return {
      'VISA': [
          {
              disputeType: 'Allocation',
              dataColumns: [
                  {
                      description: 'Why are you Initiating this Response?',
                      required: true,
                      name: 'Why are you Initiating this Response?',
                      displayType: 'DROPDOWN',
                      columnKey: 'responseReason',
                      width: 725,
                      list: [
                          {
                              value: 'ND',
                              text: 'ND - CardHolder No Longer Disputes',

                          },
                          {
                              value: 'CP',
                              text: 'CP - Credit or Reversal Processed'
                          },
                          {
                              value: 'ID',
                              text: 'ID - Invalid Dispute'
                          },
                          {
                              value: 'MI',
                              text: 'MI - Proof of Manual Imprint'
                          },
                          {
                              value: 'CE',
                              text: 'CE - Compelling Evidence'
                          },
                          {
                              value: 'DC',
                              text: 'DC - Delayed charge transaction'
                          },
                      ]
                  },

              ]
          },
          {
              disputeType: 'Collaboration',
              dataColumns: [
                  {
                      description: 'Response Reason',
                      required: true,
                      name: 'Response Reason',
                      displayType: 'DROPDOWN',
                      columnKey: 'responseReason',
                      width: 725,
                      list: [
                          {
                              value: 'CNLD',
                              text: 'CNLD - Cardholder No Longer Disputes',
                          },
                          {
                              value: 'CE',
                              text: 'CE - Compelling Evidence',
                          },
                          {
                              value: 'CP',
                              text: 'CP - Credit or Reversal Processed',
                          },
                          {
                              value: 'ID',
                              text: 'ID - Invalid Dispute',
                          },
                          {
                              value: 'RM',
                              text: 'RM - Reversal issued by merchant',
                          },
                          {
                              value: 'NL',
                              text: 'NL - Not listed above',
                          },
                          {
                              value: 'FC',
                              text: 'FC - Non-fiat currency or non-fungible token',
                          }
                      ]
                  },
                  {
                      name: 'Why are you not accepting full liability? (required)',
                      columnKey: 'resonNotAcceptLiability',
                      required: true,
                      description: 'Why are you not accepting full liability',
                      displayType: 'TEXTAREA',
                      width: 725,
                      height: 175,
                      length: 0,
                      textAreaMaxLength: 1000,
                      height: 150,
                      float: 'left',
                  }
              ]
          },
      ]
  }

}
export function getLevelTwoComponents() {
  return {
      'VISA': [
          {
              reason: 'CE',
              disputeType: 'Allocation',
              dataColumns: [
                  {
                      description: 'Compelling Evidence Type',
                      required: true,
                      name: 'Compelling Evidence Type',
                      displayType: 'DROPDOWN',
                      columnKey: 'compellingEvidenceType',
                      width: 750,
                      float: 'left',
                      list: [
                          {
                              value: 'CE01',
                              text: 'CE01 - Documentaiton to prove the cardholder is in posession',
                              disputeType: 'Allocation',
                              reason: 'CE01'
                          },
                          {
                              value: 'CE02',
                              text: 'CE02 - Signed delivery form, copy of/details of identification',
                              disputeType: 'Allocation',
                              reason: 'CE02'
                          },
                          {
                              value: 'CE03',
                              text: 'CE03 - AVS or Y or M and proof of delivery (date and time)',
                              disputeType: 'Allocation',
                              reason: 'CE03'
                          },
                          {
                              value: 'CE04',
                              text: 'CE04 - Digitalgoods download with time and date',
                              disputeType: 'Allocation',
                              reason: 'CE04'
                          },
                          {
                              value: 'CE05',
                              text: 'CE05 - Delivery to cardholder at place of employment',
                              disputeType: 'Allocation',
                              reason: 'CE05'
                          },
                          {
                              value: 'CE06',
                              text: 'CE06 - T and E loyalty transactions related to purchase',
                              disputeType: 'Allocation',
                              reason: 'CE06'
                          },
                          {
                              value: 'CE07',
                              text: 'CE07 - T and E subsequent purchases made throughout service period',
                              disputeType: 'Allocation',
                              reason: 'CE07'
                          },
                          {
                              value: 'CE08',
                              text: 'CE08 - Passenger Transport proof ticket was received, scanned at gate',
                              disputeType: 'Allocation',
                              reason: 'CE08'
                          },
                          {
                              value: 'CE09',
                              text: 'CE09 - Evidence of non disputed transactions/ OCT',
                              disputeType: 'Allocation',
                              reason: 'CE09'
                          },
                          {
                              value: 'CE11',
                              text: 'CE11 - Signed Mail Order/Phone Order form',
                              disputeType: 'Allocation',
                              reason: 'CE11'
                          },
                          {
                              value: 'CE12',
                              text: 'CE12 - Legitimate spend across multiple payment types for same',
                              disputeType: 'Allocation',
                              reason: 'CE12'
                          },
                          {
                              value: 'CE13',
                              text: 'CE13 - Recurring transaction with binding contract or previous undisputed',
                              disputeType: 'Allocation',
                              reason: 'CE13'
                          },
                          {
                              value: 'CE14',
                              text: 'CE14 - Signer is member of cardholder\'s household',
                              disputeType: 'Allocation',
                              reason: 'CE14'
                          },
                          {
                            value: 'CE15',
                            text: 'CE15 - Flight Manifest with corresponding purchase itenerary record',
                            disputeType: 'Allocation',
                            reason: 'CE15'
                          },
                          {
                            value: 'CE16',
                            text: 'CE16 - Non-fiat currency or non-fungible token',
                            disputeType: 'Allocation',
                            reason: 'CE16'
                          },
                          {
                            value: 'CE17',
                            text: 'CE17 - Evidence that the same card used in the disputed transaction was used in another transaction that was not disputed',
                            disputeType: 'Allocation',
                            reason: 'CE17'
                          },
                          {
                            value: 'CE18',
                            text: 'CE18 - Copy of identification presented by the Cardholder along with either receipt, contract or invoice',
                            disputeType: 'Allocation',
                            reason: 'CE18'
                          },
                      ]
                  },
                  {
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      columnKey: 'idCollaborationCheckbox',
                      float: 'right',
                      isChecked: true,
                  },
              ]
          },
          {
              reason: 'CE',
              disputeType: 'Collaboration',
              dataColumns: [
                  {
                      description: 'Compelling Evidence Type',
                      required: true,
                      name: 'Compelling Evidence Type',
                      displayType: 'DROPDOWN',
                      columnKey: 'compellingEvidenceType',
                      width: 750,
                      float: 'left',
                      list: [
                          {
                              value: 'CE01',
                              text: 'CE01 - Documentaiton to prove the cardholder is in posession',
                              disputeType: 'Collaboration',
                              reason: 'CE01'
                          },
                          {
                              value: 'CE02',
                              text: 'CE02 - Signed delivery form, copy of/details of identification',
                              disputeType: 'Collaboration',
                              reason: 'CE02'
                          },
                          {
                              value: 'CE03',
                              text: 'CE03 - AVS or Y or M and proof of delivery (date and time)',
                              disputeType: 'Collaboration',
                              reason: 'CE03'
                          },
                          {
                              value: 'CE04',
                              text: 'CE04 - Digitalgoods download with time and date',
                              disputeType: 'Collaboration',
                              reason: 'CE04'
                          },
                          {
                              value: 'CE05',
                              text: 'CE05 - Delivery to cardholder at place of employment',
                              disputeType: 'Collaboration',
                              reason: 'CE05'
                          },
                          {
                              value: 'CE06',
                              text: 'CE06 - T and E loyalty transactions related to purchase',
                              disputeType: 'Collaboration',
                              reason: 'CE06'
                          },
                          {
                              value: 'CE07',
                              text: 'CE07 - T and E subsequent purchases made throughout service period',
                              disputeType: 'Collaboration',
                              reason: 'CE07'
                          },
                          {
                              value: 'CE08',
                              text: 'CE08 - Passenger Transport proof ticket was received, scanned at gate',
                              disputeType: 'Collaboration',
                              reason: 'CE08'
                          },
                          {
                              value: 'CE10',
                              text: 'CE10 - Authorized signer known by the cardholder',
                              disputeType: 'Collaboration',
                              reason: 'CE10'
                          },
                      ]
                  },
                  {
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      columnKey: 'idCollaborationCheckbox',
                      float: 'right',
                      isChecked: true,
                  },
              ]
          },
          {
              reason: 'ND',
              disputeType: 'Allocation',
              dataColumns: [
                  {
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      columnKey: 'idCollaborationCheckbox',
                      float: 'right',
                      isChecked: true,
                  }
              ]
          },
           {
              reason: 'DC',
              disputeType: 'Allocation',
              dataColumns: [
                  {
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      columnKey: 'idCollaborationCheckbox',
                      float: 'right',
                      isChecked: true,
                  }
              ]
          },
          {
              reason: 'CNLD',
              disputeType: 'Collaboration',
              dataColumns: [
                  {
                      name: 'Dispute Response Reason Explanation (required)',
                      required: true,
                      description: 'Dispute Response Reason Explanation',
                      width: 725,
                      displayType: 'TEXTAREA',
                      columnKey: 'disputeReasonExpl',
                      length: 0,
                      textAreaMaxLength: 1000,
                      height: 150,
                      float: 'left',
                  },
                  {
                      name: 'Dispute Amount',
                      description: 'Dispute Amount',
                      columnKey: 'disputeAmount',
                      inputType: 'number',
                      width: 224,
                      currencyWidth:100,
                      length: 0,
                      float: 'left',
                      displayType: 'AMOUNT',
                  },
                  {
                    name: 'Dispute Currency',
                    description: 'Dispute Currency',
                    columnKey: 'disputeCurrency',
                    currencyWidth:80,
                    length: 0,
                    displayType: 'CURRENCY',
                },
                  {
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      columnKey: 'idCollaborationCheckbox',
                      float: 'right',
                      isChecked: true,
                  }
              ]
          },
          {
            reason: 'FC',
            disputeType: 'Collaboration',
            dataColumns: [ 
               {
                        name: 'Destination Wallet Address (required)',
                        required: true,
                        description: 'Destination Wallet Address',
                        width: 725,
                        displayType: 'TEXTAREA',
                        columnKey: 'destinationWalletAddress',
                        length: 0,
                        textAreaMaxLength: 1000,
                        height: 150,
                        float: 'left',
                },
                {
                        name: 'Blockchain Transaction Hash (required)',
                        required: true,
                        description: 'Blockchain Transaction Hash',
                        width: 725,
                        displayType: 'TEXTAREA',
                        columnKey: 'blockchainTransactionHash',
                        length: 0,
                        textAreaMaxLength: 1000,
                        height: 150,
                        float: 'left',
                  },
                  {
                        name: 'Prior approved similar transaction using same cardholder account number',
                        required: true,
                        description: 'Prior approved similar transaction using same cardholder account number',
                        width: 725,
                        displayType: 'TEXTAREA',
                        columnKey: 'priorSimilarTransaction',
                        length: 0,
                        textAreaMaxLength: 5000,
                        height: 150,
                        float: 'left',
                  },
                  {
                        name: 'Attach Documents',
                        required: true,
                        type: 'attachDoc',
                        description: 'Attach Documents',
                        displayType: 'CHECKBOX',
                        columnKey: 'idCollaborationCheckbox',
                        float: 'right',
                        isChecked: true,
                  }
            ]
        },
          {
              reason: 'RM',
              disputeType: 'Collaboration',
              dataColumns: [
                  {
                      name: 'Dispute Response Reason Explanation (required)',
                      required: true,
                      description: 'Dispute Response Reason Explanation',
                      width: 725,
                      displayType: 'TEXTAREA',
                      columnKey: 'disputeReasonExplRM',
                      length: 0,
                      textAreaMaxLength: 1000,
                      height: 150,
                      float: 'left',
                  },{
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      columnKey: 'idCollaborationCheckbox',
                      float: 'right',
                      isChecked: true,
                  }
              ]
          },
          {
              reason: 'CP',
              disputeType: 'Allocation',
              dataColumns: [
                  {
                      description: 'Please select one of the options',
                      required: true,
                      name: 'Please select one of the options',
                      displayType: 'DROPDOWN',
                      columnKey: 'idCreditReversalDropDown',
                      width: 725,
                      list: [
                          {
                              value: 'CP01',
                              text: 'Credit/Reversal Details',
                              disputeType: 'Allocation',
                              reason: 'CP',
                          },
                          {
                              value: 'CP02',
                              text: 'Explanation why Cedit/Reversal does not apply',
                              disputeType: 'Allocation',
                              reason: 'CP',
                          },
                      ]
                  },
                  {
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      columnKey: 'idCollaborationCheckbox',
                      float: 'right',
                      isChecked: true,
                  }
              ]
          },
          {
              reason: 'CP',
              disputeType: 'Collaboration',
              dataColumns: [
                  {
                      description: 'Please select one of the options',
                      required: true,
                      name: 'Please select one of the options',
                      displayType: 'DROPDOWN',
                      columnKey: 'idCreditReversalDropDown',
                      width: 750,
                      float: 'left',
                      list: [
                          {
                              value: 'CP01',
                              text: 'Credit/Reversal Details',
                              disputeType: 'Collaboration',
                              reason: 'CP',
                          },
                          {
                              value: 'CP02',
                              text: 'Explanation why Cedit/Reversal does not apply',
                              disputeType: 'Collaboration',
                              reason: 'CP',
                          },
                      ]
                  },
                  {
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      columnKey: 'idCollaborationCheckbox',
                      float: 'right',
                      isChecked: true,
                  }
              ]
          },
          {
              reason: 'ID',
              disputeType: 'Allocation',
              dataColumns: [
                  {
                      description: 'Explain why the Dispute is invalid',
                      required: true,
                      name: 'Explain why the Dispute is invalid',
                      displayType: 'DROPDOWN',
                      columnKey: 'invalidDisputeReason',
                      width: 725,
                      list:[],
                  },
                  {
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      columnKey: 'idCollaborationCheckbox',
                      float: 'right',
                      isChecked: true,
                  }
              ]
          },
          {
              reason: 'ID',
              disputeType: 'Collaboration',
              dataColumns: [
                  {
                      name: 'Authorization Date',
                      required: false,
                      description: 'Authorization Date',
                      displayType: 'SINGLEDATE',
                      columnKey: 'colbAuthorizationDate',
                      width: '362px',
                      float: 'left',
                      paddingRight:'30px',
                  },
                  {
                      name: 'Correct Transaction Date',
                      required: false,
                      description: 'Correct Transaction Date',
                      displayType: 'SINGLEDATE',
                      columnKey: 'colbTransactionDate',
                      width: '362px',
                      float: 'left',
                  },
                  {
                      description: 'Explain why the Dispute is invalid',
                      required: true,
                      name: 'Explain why the Dispute is invalid',
                      displayType: 'DROPDOWN',
                      columnKey: 'invalidDisputeReason',
                      width: 750,
                      float: 'left',
                      list:[],
                  },
                  {
                      name: 'Dispute Response Reason Explanation',
                      required: false,
                      description: 'Dispute Response Reason Explanation',
                      width: 725,
                      displayType: 'TEXTAREA',
                      columnKey: 'disputeReasonExplID',
                      length: 0,
                      textAreaMaxLength: 1000,
                      height: 150,
                      float: 'left',
                  },
                  {
                      name: 'Provide brief invalid dispute reason that was not listed',
                      required: false,
                      description: 'Provide brief invalid dispute reason that was not listed',
                      width: 725,
                      displayType: 'TEXTAREA',
                      columnKey: 'briefInvalidReasonID',
                      length: 0,
                      textAreaMaxLength: 1000,
                      height: 150,
                      float: 'left',
                  },
                  {
                      name: 'What cancellation date did the cardholder request?',
                      required: true,
                      description: 'What cancellation date did the cardholder request?',
                      displayType: 'SINGLEDATE',
                      columnKey: 'colbCancellationDate',
                      width: '362px',
                      float: 'left',
                      paddingRight:'30px',
                  },
                  {
                    name: 'Dispute Amount',
                    description: 'Dispute Amount',
                    columnKey: 'disputeAmount',
                    inputType: 'number',
                    width: 224,
                    length: 0,
                    float: 'left',
                    displayType: 'AMOUNT',
                  },
                  {
                    name: 'Dispute Currency',
                    description: 'Dispute Currency',
                    columnKey: 'disputeCurrency',
                    currencyWidth:80,
                    length: 0,
                    displayType: 'CURRENCY',
                  },
                  {
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      columnKey: 'idCollaborationCheckbox',
                      float: 'right',
                      isChecked: true,
                  }
              ]
          },
          {
              reason: 'MI',
              disputeType: 'Allocation',
              dataColumns: [
                  {
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      columnKey: 'idCollaborationCheckbox',
                      float: 'right',
                      isChecked: true,
                  }
              ]
          },
          {
              reason: 'NL',
              disputeType: 'Collaboration',
              dataColumns: [
                  {
                      name: 'Dispute Response Reason Explanation (required)',
                      required: true,
                      description: 'Dispute Response Reason Explanation',
                      width: 725,
                      displayType: 'TEXTAREA',
                      columnKey: 'disputeReasonExplNL',
                      length: 0,
                      textAreaMaxLength: 1000,
                      height: 150,
                      float: 'left',
                  },
                  {
                    name: 'Dispute Amount',
                    description: 'Dispute Amount',
                    columnKey: 'disputeAmount',
                    inputType: 'number',
                    width: 224,
                    length: 0,
                    float: 'left',
                    displayType: 'AMOUNT',
                  },
                  {
                    name: 'Dispute Currency',
                    description: 'Dispute Currency',
                    columnKey: 'disputeCurrency',
                    currencyWidth:80,
                    length: 0,
                    displayType: 'CURRENCY',
                  },
                  {
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      columnKey: 'idCollaborationCheckbox',
                      float: 'right',
                      isChecked: true,
                  }
              ]
          },
          {
              reason: 'CDLT',
              disputeType: 'Collaboration',
              dataColumns: [
                  {
                      name: 'Dispute Response Reason Explanation (required)',
                      required: true,
                      description: 'Dispute Response Reason Explanation',
                      width: 725,
                      displayType: 'TEXTAREA',
                      columnKey: 'disputeReasonExplCDLT',
                      length: 0,
                      textAreaMaxLength: 1000,
                      height: 150,
                      float: 'left',
                  },
                  {
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      columnKey: 'idCollaborationCheckbox',
                      float: 'right',
                      isChecked: true,
                  }
              ]
          },

      ]
  }
}
export function getLevelThreeComponents(autoPopulateDetails) {
  return {
      'VISA': [
          {
              reason: 'CE',
              disputeType: 'Allocation',
              dataColumnKey: 'CE02',
              dataColumns: [
                  {
                      name: 'Attach Documents',
                      required: true,
                      type: 'attachDoc',
                      description: 'Attach Documents',
                      displayType: 'CHECKBOX',
                      isChecked: true,
                      columnKey: 'ce02AllocationCheckbox',
                  }

              ]
          }, {
              reason: 'CE',
              disputeType: 'Allocation',
              dataColumnKey: 'CE03',
              dataColumns: [
                  {
                      name: 'Name',
                      required: false,
                      description: 'Name',
                      displayType: 'TEXT',
                      columnKey: 'ce03AlocName',
                      width: 750,
                      float: 'left',
                      max: 50,
                  },
                  {
                      name: 'Address 1',
                      required: false,
                      description: 'Address 1',
                      displayType: 'TEXTAREA',
                      columnKey: 'ce03AlocAddress1',
                      width: 375,
                      float: 'left',
                      height: 40,
                      textAreaMaxLength: 50,
                  },
                  {
                      name: 'Address 2',
                      required: false,
                      description: 'Address 2',
                      displayType: 'TEXTAREA',
                      columnKey: 'ce03AlocAddress2',
                      width: 375,
                      float: 'left',
                      height: 40,
                      textAreaMaxLength: 50,
                  },
                  {
                      name: 'City',
                      required: false,
                      description: 'City',
                      displayType: 'TEXT',
                      columnKey: 'ce03AlocCity',
                      width: 187.5,
                      float: 'left',
                      max: 50,
                  },
                  {
                      name: 'State',
                      required: false,
                      description: 'State',
                      displayType: 'DROPDOWN',
                      columnKey: 'ce03AlocState',
                      width: 187.5,
                      float: 'left',
                      list : [
                          {
                            "text": "ALABAMA",
                            "value": "AL"
                          },
                          {
                            "text": "ALASKA",
                            "value": "AK"
                          },
                          {
                            "text": "ALBERTA",
                            "value": "AB"
                          },
                          {
                            "text": "AMERICAN SAMOA",
                            "value": "AS"
                          },
                          {
                            "text": "ARIZONA",
                            "value": "AZ"
                          },
                          {
                            "text": "ARKANSAS",
                            "value": "AR"
                          },
                          {
                            "text": "AUSTRALIAN CAPITAL TERRITORY",
                            "value": "CT1"
                          },
                          {
                            "text": "BRITISH COLUMBIA",
                            "value": "BC"
                          },
                          {
                            "text": "CALIFORNIA",
                            "value": "CA"
                          },
                          {
                            "text": "COLORADO",
                            "value": "CO"
                          },
                          {
                            "text": "CONNECTICUT",
                            "value": "CT"
                          },
                          {
                            "text": "DELAWARE",
                            "value": "DE"
                          },
                          {
                            "text": "DISTRICT OF COLUMBIA",
                            "value": "DC"
                          },
                          {
                            "text": "DISTRITO FEDERAL",
                            "value": "DF"
                          },
                          {
                            "text": "FEDERATED STATES OF MICRONESIA",
                            "value": "FM"
                          },
                          {
                            "text": "FLORIDA",
                            "value": "FL"
                          },
                          {
                            "text": "GEORGIA",
                            "value": "GA"
                          },
                          {
                            "text": "GUAM",
                            "value": "GU"
                          },
                          {
                            "text": "HAWAII",
                            "value": "HI"
                          },
                          {
                            "text": "IDAHO",
                            "value": "id"
                          },
                          {
                            "text": "ILLINOIS",
                            "value": "IL"
                          },
                          {
                            "text": "INDIANA",
                            "value": "IN"
                          },
                          {
                            "text": "IOWA",
                            "value": "IA"
                          },
                          {
                            "text": "KANSAS",
                            "value": "KS"
                          },
                          {
                            "text": "KENTUCKY",
                            "value": "KY"
                          },
                          {
                            "text": "LOUISIANA",
                            "value": "LA"
                          },
                          {
                            "text": "MAINE",
                            "value": "ME"
                          },
                          {
                            "text": "MANITOBA",
                            "value": "MB"
                          },
                          {
                            "text": "MARSHALL ISLANDS",
                            "value": "MH"
                          },
                          {
                            "text": "MARYLAND",
                            "value": "MD"
                          },
                          {
                            "text": "MASSACHUSETTS",
                            "value": "MA"
                          },
                          {
                            "text": "MICHIGAN",
                            "value": "MI1"
                          },
                          {
                            "text": "MINNESOTA",
                            "value": "MN"
                          },
                          {
                            "text": "MISSISSIPPI",
                            "value": "MS"
                          },
                          {
                            "text": "MISSOURI",
                            "value": "MO"
                          },
                          {
                            "text": "MONTANA",
                            "value": "MT"
                          },
                          {
                            "text": "NORTH CAROLINA",
                            "value": "NC"
                          },
                          {
                            "text": "NEBRASKA",
                            "value": "NE"
                          },
                          {
                            "text": "NEVADA",
                            "value": "NV"
                          },
                          {
                            "text": "NEW BRUNSWICK",
                            "value": "NB"
                          },
                          {
                            "text": "NEW HAMPSHIRE",
                            "value": "NH"
                          },
                          {
                            "text": "NEW JERSEY",
                            "value": "NJ"
                          },
                          {
                            "text": "NEW MEXICO",
                            "value": "NM"
                          },
                          {
                            "text": "NEW SOUTH WALES",
                            "value": "NS"
                          },
                          {
                            "text": "NEW YORK",
                            "value": "NY"
                          },
                          {
                            "text": "NEWFOUNDLAND AND LABRADOR",
                            "value": "NL1"
                          },
                          {
                            "text": "NORTH DAKOTA",
                            "value": "ND1"
                          },
                          {
                            "text": "NORTHERN MARIANA ISLANDS",
                            "value": "MP"
                          },
                          {
                            "text": "NORTHERN TERRITORY",
                            "value": "NT"
                          },
                          {
                            "text": "NORTHWEST TERRITORIES",
                            "value": "NT1"
                          },
                          {
                            "text": "NOVA SCOTIA",
                            "value": "NS1"
                          },
                          {
                            "text": "NUNAVUT",
                            "value": "NU"
                          },
                          {
                            "text": "OHIO",
                            "value": "OH"
                          },
                          {
                            "text": "OKLAHOMA",
                            "value": "OK"
                          },
                          {
                            "text": "ONTARIO",
                            "value": "ON"
                          },
                          {
                            "text": "OREGON",
                            "value": "OR"
                          },
                          {
                            "text": "PALAU",
                            "value": "PW"
                          },
                          {
                            "text": "PENNSYLVANIA",
                            "value": "PA"
                          },
                          {
                            "text": "PRINCE EDWARD ISLAND",
                            "value": "PE"
                          },
                          {
                            "text": "PUERTO RICO",
                            "value": "PR"
                          },
                          {
                            "text": "QUEBEC",
                            "value": "QC"
                          },
                          {
                            "text": "QUEENSLAND",
                            "value": "QL"
                          },
                          {
                            "text": "RHODE ISLAND",
                            "value": "RI"
                          },
                          {
                            "text": "SASKATCHEWAN",
                            "value": "SK"
                          },
                          {
                            "text": "SOUTH AUSTRALIA",
                            "value": "SA"
                          },
                          {
                            "text": "SOUTH CAROLINA",
                            "value": "SC"
                          },
                          {
                            "text": "SOUTH DAKOTA",
                            "value": "SD"
                          },
                          {
                            "text": "TASMANIA",
                            "value": "TS"
                          },
                          {
                            "text": "TENNESSEE",
                            "value": "TN"
                          },
                          {
                            "text": "TEXAS",
                            "value": "TX"
                          },
                          {
                            "text": "U.S. VIRGIN ISLANDS",
                            "value": "VI"
                          },
                          {
                            "text": "UTAH",
                            "value": "UT"
                          },
                          {
                            "text": "VERMONT",
                            "value": "VT"
                          },
                          {
                            "text": "VICTORIA",
                            "value": "VI1"
                          },
                          {
                            "text": "VIRGINIA",
                            "value": "VA"
                          },
                          {
                            "text": "WASHINGTON",
                            "value": "WA"
                          },
                          {
                            "text": "WEST VIRGINIA",
                            "value": "WV"
                          },
                          {
                            "text": "WESTERN AUSTRALIA",
                            "value": "WA1"
                          },
                          {
                            "text": "WISCONSIN",
                            "value": "WI"
                          },
                          {
                            "text": "WYOMING",
                            "value": "WY"
                          },
                          {
                            "text": "YUKON TERRITORY",
                            "value": "YT"
                          }
                        ]
                  },
                  {
                      name: 'Postal Code',
                      required: false,
                      description: 'Postal Code',
                      displayType: 'TEXT',
                      columnKey: 'ce03AlocPostalCode',
                      width: 187.5,
                      float: 'left',
                      max: 9,
                  },
                  {
                      name: 'Country',
                      required: false,
                      description: 'Country',
                      displayType: 'DROPDOWN',
                      columnKey: 'ce03AlocCountry',
                      width: 187.5,
                      float: 'left',
                      list: [
                          {
                            "text": "United States",
                            "value": "USA"
                          },
                          {
                            "text": "United Kingdom",
                            "value": "GBR"
                          },
                          {
                            "text": "Macau",
                            "value": "MAC"
                          },
                          {
                            "text": "Malaysia",
                            "value": "MYS"
                          },
                          {
                            "text": "Brunei",
                            "value": "BRN"
                          },
                          {
                            "text": "Maldives",
                            "value": "MDV"
                          },
                          {
                            "text": "Sri Lanka",
                            "value": "LKA"
                          },
                          {
                            "text": "Canada",
                            "value": "CAN"
                          },
                          {
                            "text": "Bermuda",
                            "value": "BMU"
                          },
                          {
                            "text": "Singapore",
                            "value": "SGP"
                          },
                          {
                            "text": "India",
                            "value": "IND"
                          },
                          {
                            "text": "Philippines",
                            "value": "PHL"
                          },
                          {
                            "text": "Hong Kong",
                            "value": "HKG"
                          }
                        ]
                  },
                  {
                      name: 'Shipping Company Name',
                      required: false,
                      description: 'Shipping Company Name',
                      displayType: 'DROPDOWN',
                      columnKey: 'ce03AlocShippingCompany',
                      width: 375,
                      float: 'left',
                      list: [
                          {
                              text: 'D-DHL',
                              value: 'D',
                          },
                          {
                              text: 'FE-Fed Ex',
                              value: 'FE',
                          },
                          {
                              text: 'P-Postal Service',
                              value: 'P',
                          },
                          {
                              text: 'U-UPS',
                              value: 'U',
                          },
                          {
                              text: 'O-Other',
                              value: 'O',
                          }
                      ]
                  },
                  {
                      name: 'Tracking Number',
                      required: false,
                      description: 'Tracking Number',
                      displayType: 'TEXT',
                      inputType: 'text',
                      columnKey: 'ce03AlocTrackNo',
                      width: 375,
                      float: 'left',
                      max: 50,
                  },
              ]
          },
          {
              reason: 'CE',
              disputeType: 'Allocation',
              dataColumnKey: 'CE04',
              dataColumns: [
                  {
                      name: 'Describe what was Downloaded',
                      required: true,
                      description: 'Describe what was Downloaded',
                      displayType: 'TEXT',
                      columnKey: 'ace04DescDownloaded',
                      width: 750,
                      float: 'left',
                      max: 10000
                  },
                  {
                      name: 'Download Date',
                      required: true,
                      description: 'Download Date',
                      displayType: 'SINGLEDATE',
                      columnKey: 'ace04DownloadDate',
                      width: '362.5px',
                      float: 'left',
                      paddingRight: '30px'
                  },
                  {
                      name: 'Download Time',
                      required: false,
                      description: 'Download Time',
                      displayType: 'TIME',
                      columnKey: 'ace04DownloadTime',
                      width: '362.5px',
                      float: 'left',
                  },
                  {
                      name: 'Select at least two options below.',
                      description: 'Select at least two options below.',
                      columnKey: '',
                      displayType: 'LABEL',
                      float: 'left',
                  },
                  {
                      name: `Proof that the merchant's website or application was accessed by the cardholder for merchandise or services on or after the transaction date.`,
                      required: true,
                      attachArray: [{
                          name: 'Describe the Proof',
                          required: true,
                          description: 'Describe the Proof',
                          displayType: 'TEXT',
                          columnKey: 'ace04DescProof',
                          width: 700,
                          float: 'left',
                          paddingLeft:'44px',
                          max: 10000
                      }],
                      type: '',
                      description: `Proof that the merchant's website or application was accessed by the cardholder for merchandise
                      or services on or after the transaction date.`,
                      displayType: 'CHECKBOX',
                      width: 725,
                      columnKey: 'ace04ProofWebAccess',
                      float: 'left',
                  },
                  {
                      displayType: 'LINE',
                  },
                  {
                      name: `Evidence that the profile set up by the purchaser on the merchant's website or application was accessed by the purchaser and has been successfully verified by the merchant before the transaction date.`,
                      required: true,
                      attachArray: [{
                          name: 'Describe the Evidence',
                          required: true,
                          description: 'Describe the Evidence',
                          displayType: 'TEXT',
                          columnKey: 'ace04DescEvid',
                          width: 700,
                          float: 'left',
                          paddingLeft:'44px',
                          max: 10000
                      }],
                      type: '',
                      description: `Evidence that the profile set up by the purchaser on the merchant's website or application was accessed by 
                      the purchaser and has been successfully verified by the merchant before the transaction date.`,
                      displayType: 'CHECKBOX',
                      columnKey: 'ace04EvidenceWebAccess',
                      width: 725,
                      float: 'left',
                  },
                  {
                      displayType: 'LINE',
                  },
                  {
                      name: `Evidence that the same device and card used in the disputed transaction were used in a previous transaction that was not disputed.`,
                      required: true,
                      attachArray: [
                          {
                              name: 'Acquirer Reference Number',
                              required: true,
                              description: 'Acquirer Reference Number',
                              displayType: 'TEXT',
                              columnKey: 'ace04ARN',
                              width: 700,
                              float: 'left',                             
                              paddingLeft:'44px',
                              max: 24,
                              validate: numeric
                          },
                          {
                              name: 'Transaction Amount',
                              required: true,
                              description: 'Transaction Amount',
                              displayType: 'TEXT',
                              columnKey: 'ace04TransacAmount',
                              width: 350,
                              float: 'left',                             
                              paddingLeft:'44px',
                              max: 14,
                              validate: (value) => decimalNumber(value, 13),
                          },
                          {
                              name: 'Transaction Date',
                              required: true,
                              description: 'Transaction Date',
                              displayType: 'SINGLEDATE',
                              columnKey: 'ace04TranDate',
                              width: 325,
                              float: 'left',                             
                              paddingLeft:'44px',
                              paddingRight:'0px',
                          }

                      ],
                      type: '',
                      description: `Evidence that the same device and card used in the disputed transaction were used in a previous transaction
                      that was not disputed.`,
                      displayType: 'CHECKBOX',
                      columnKey: 'ace04EvidenceSameDevice',
                      width: 725,
                      float: 'left',
                  },
                  {
                      displayType: 'LINE',
                  },
                  {
                      name: `Purchaser's IP address and the device geographical location at the date and time of the Transaction.`,
                      required: true,
                      attachArray: [
                          {
                              name: 'Geographical Location',
                              required: true,
                              description: 'Geographical Location',
                              displayType: 'TEXT',
                              columnKey: 'ace04GeoLocation',
                              width: 350,
                              float: 'left', 
                              paddingLeft:'44px',
                              max: 50
                          }, {
                              name: 'Purchaser\'s IP address',
                              required: true,
                              description: 'Purchaser\'s IP address',
                              displayType: 'TEXT',
                              columnKey: 'ace04GeoPurcheserIP',
                              width: 350,
                              float: 'left',  
                              paddingLeft:'44px',
                              max: 50
                          }],
                      type: '',
                      description: `Purchaser's IP address and the device geographical location at the date and time of the Transaction.`,
                      displayType: 'CHECKBOX',
                      selected: true,
                      columnKey: 'ace04PurchaserIp',
                      width: 750,
                      float: 'left',
                      paddingTop: 15,
                  },
                  {
                      displayType: 'LINE',
                  },
                  {
                      name: `Purchaser's name and email address linked to the customer profile held by the merchant.`,
                      required: true,
                      attachArray: [
                          {
                              name: 'Purchaser\'s Email Address',
                              required: true,
                              description: 'Purchaser\'s Email Address',
                              displayType: 'TEXT',
                              columnKey: 'ace04PurchasrEmail',
                              width: 350,
                              float: 'left',
                              paddingLeft:'44px',
                              max: 50
                          }, {
                              name: 'Purchaser\'s Name',
                              required: true,
                              description: 'Purchaser\'s Name',
                              displayType: 'TEXT',
                              columnKey: 'ace04PurchasrName',
                              width: 350,
                              float: 'left',
                              paddingLeft:'44px',  
                              max: 50
                          }],
                      type: '',
                      description: `Purchaser's name and email address linked to the customer profile held by the merchant.`,
                      displayType: 'CHECKBOX',
                      selected: true,
                      columnKey: 'ace04PurchaserName',
                      width: 750,
                      float: 'left',
                      paddingTop: 15,
                  },
                  {
                      displayType: 'LINE',
                  },
                  {
                      name: `Device ID and name of device Ind.`,
                      required: true,
                      attachArray: [
                          {
                              name: 'Device ID',
                              required: true,
                              description: 'Device ID',
                              displayType: 'TEXT',
                              columnKey: 'ace04DevId',
                              width: 350,
                              float: 'left',
                              paddingLeft:'44px',
                              max: 50
                          }, {
                              name: 'Name of device',
                              required: true,
                              description: 'Name of device',
                              displayType: 'TEXT',
                              columnKey: 'ace04DeviceName',
                              width: 350,
                              float: 'left',                              
                              paddingLeft:'44px',  
                              max: 50
                          }],
                      type: '',
                      description: `Device ID and name of device Ind.`,
                      displayType: 'CHECKBOX',
                      selected: true,
                      columnKey: 'ace04DeviceIDName',
                      width: 750,
                      float: 'left',
                      paddingTop: 15,
                  }
              ]
          },
          {
              reason: 'CE',
              disputeType: 'Allocation',
              dataColumnKey: 'CE09',
              dataColumns: [
                  {
                      name: `Evidence that the same device and card used in the disputed transaction were used in a previous transaction that was not disputed.`,
                      required: true,
                      attachArray: [
                          {
                              name: 'Acquirer Reference Number',
                              required: true,
                              description: 'Acquirer Reference Number',
                              displayType: 'TEXT',
                              columnKey: 'ace09ARN',
                              width: 700,
                              float: 'left', 
                              paddingLeft:'44px',
                              max: 24,
                              validate: numeric,
                          },
                          {
                              name: 'Transaction Amount',
                              required: true,
                              description: 'Transaction Amount',
                              displayType: 'TEXT',
                              columnKey: 'ace09TranAmount',
                              width: 350,
                              float: 'left',                             
                              paddingLeft:'44px',
                              max: 14,
                              validate: (value) => decimalNumber(value, 13),
                          },
                          {
                              name: 'Transaction Date',
                              required: true,
                              description: 'Transaction Date',
                              displayType: 'SINGLEDATE',
                              columnKey: 'ace09TranDate',
                              width: 325,
                              float: 'left',                            
                              paddingLeft:'44px',
                              paddingRight:'0px',
                          }
                         ],
                      type: '',
                      description: `Evidence that the same device and card used in the disputed transaction were used in a previous transaction
                      that was not disputed.`,
                      displayType: 'CHECKBOX',
                      selected: true,
                      width:750,
                      columnKey: 'ace09EvidenceSameDevice',
                      float: 'left',                           
                  },
                  {
                      name: 'Choose at least three from the below options.',
                      description: 'Choose at least three from the below options.',
                      columnKey: 'ace09ChooseOption',
                      displayType: 'LABEL',
                      float: 'left',                           
                  },
                  {
                      name: 'Email Address',
                      required: true,
                      type: '',
                      description: 'Email Address',
                      displayType: 'CHECKBOX',
                      selected: true,
                      columnKey: 'ace09EmailAddress',
                      float: 'left',
                  },
                  {
                      name: 'IP Address',
                      required: true,
                      type: '',
                      description: 'IP Address',
                      displayType: 'CHECKBOX',
                      selected: true,
                      columnKey: 'ace09IPAddress',
                      float: 'left',
                  },
                  {
                      name: 'Phone Number',
                      required: true,
                      type: '',
                      description: 'Phone Number',
                      displayType: 'CHECKBOX',
                      inputType: 'number',
                      selected: true,
                      columnKey: 'ace09PhoneNumber',
                      float: 'left',
                  },
                  {
                      name: 'Physical Address',
                      required: true,
                      type: '',
                      description: 'Physical Address',
                      displayType: 'CHECKBOX',
                      selected: true,
                      columnKey: 'ace09PhyAddress',
                      float: 'left',
                  },
                  {
                    name: 'Device ID/Device Fingerprinting',
                    required: true,
                    type: '',
                    description: 'Device ID/Device Fingerprinting',
                    displayType: 'CHECKBOX',
                    selected: true,
                    columnKey: 'compEvidenceDeviceIDFingerprintingInd',
                    float: 'left',
                  },
                  {
                  name: 'Customer Account or Login ID',
                  required: true,
                  type: '',
                  description: 'Customer Account or Login ID',
                  displayType: 'CHECKBOX',
                  selected: true,
                  columnKey: 'compEvidenceCustAccLoginIDInd',
                  float: 'left',
                 },
                 {
                      displayType: 'LINE',
                 },
              ]
          },
          {
              reason: 'CE',
              disputeType: 'Allocation',
              dataColumnKey: 'CE13',
              dataColumns: [
                  {
                      name: `Evidence that the same device and card used in the disputed transaction were used in a previous transaction that was not disputed.`,
                      required: true,
                      attachArray: [
                          {
                              name: 'Acquirer Reference Number',
                              required: true,
                              description: 'Acquirer Reference Number',
                              displayType: 'TEXT',
                              columnKey: 'ace013ARN',
                             width: 700,
                              float: 'left', 
                              paddingLeft: '44px',                         
                              max: 24,
                              validate: numeric,
                          },
                          {
                              name: 'Transaction Amount',
                              required: true,
                              description: 'Transaction Amount',
                              displayType: 'TEXT',
                              columnKey: 'ace013TranAmount',
                              width: 350,
                              float: 'left',
                              paddingLeft: '44px', 
                              max: 14,
                              validate: (value) => decimalNumber(value, 13),                                
                          },
                          {
                              name: 'Transaction Date',
                              required: true,
                              description: 'Transaction Date',
                              displayType: 'SINGLEDATE',
                              columnKey: 'ace013TranDate',
                              width: 325,
                              float: 'left',                           
                              paddingRight:'0px',
                              paddingLeft: '44px',   
                          }
                      ],
                      type: '',
                      description: `Evidence that the same device and card used in the disputed transaction were used in a previous transaction
                      that was not disputed.`,
                      displayType: 'CHECKBOX',
                      selected: true,
                      columnKey: 'ace013EvidenceSameDevice',
                      float: 'left',                           
                      width:750,
                  },

              ]
          },
          {
              reason: 'CE',
              disputeType: 'Collaboration',
              dataColumnKey: 'CE03',
              dataColumns: [
                  {
                      name: 'Name',
                      required: false,
                      description: 'Name',
                      displayType: 'TEXT',
                      columnKey: 'ce03ColbName',
                      width: 750,
                      float: 'left',
                      max: 50,
                  },
                  {
                      name: 'Address 1',
                      required: false,
                      description: 'Address 1',
                      displayType: 'TEXT',
                      columnKey: 'ce03ColbAddress1',
                      width: 375,
                      float: 'left',
                  },
                  {
                      name: 'Address 2',
                      required: false,
                      description: 'Address 2',
                      displayType: 'TEXT',
                      columnKey: 'ce03ColbAddress2',
                      width: 375,
                      float: 'left',
                  },
                  {
                      name: 'City',
                      required: false,
                      description: 'City',
                      displayType: 'TEXT',
                      columnKey: 'ce03ColbCity',
                      width: 187.5,
                      float: 'left',
                      max: 50,
                  },
                  {
                      name: 'State',
                      required: false,
                      description: 'State',
                      displayType: 'DROPDOWN',
                      columnKey: 'ce03ColbState',
                      width: 187.5,
                      float: 'left',
                      list : [
                          {
                            "text": "ALABAMA",
                            "value": "AL"
                          },
                          {
                            "text": "ALASKA",
                            "value": "AK"
                          },
                          {
                            "text": "ALBERTA",
                            "value": "AB"
                          },
                          {
                            "text": "AMERICAN SAMOA",
                            "value": "AS"
                          },
                          {
                            "text": "ARIZONA",
                            "value": "AZ"
                          },
                          {
                            "text": "ARKANSAS",
                            "value": "AR"
                          },
                          {
                            "text": "AUSTRALIAN CAPITAL TERRITORY",
                            "value": "CT1"
                          },
                          {
                            "text": "BRITISH COLUMBIA",
                            "value": "BC"
                          },
                          {
                            "text": "CALIFORNIA",
                            "value": "CA"
                          },
                          {
                            "text": "COLORADO",
                            "value": "CO"
                          },
                          {
                            "text": "CONNECTICUT",
                            "value": "CT"
                          },
                          {
                            "text": "DELAWARE",
                            "value": "DE"
                          },
                          {
                            "text": "DISTRICT OF COLUMBIA",
                            "value": "DC"
                          },
                          {
                            "text": "DISTRITO FEDERAL",
                            "value": "DF"
                          },
                          {
                            "text": "FEDERATED STATES OF MICRONESIA",
                            "value": "FM"
                          },
                          {
                            "text": "FLORIDA",
                            "value": "FL"
                          },
                          {
                            "text": "GEORGIA",
                            "value": "GA"
                          },
                          {
                            "text": "GUAM",
                            "value": "GU"
                          },
                          {
                            "text": "HAWAII",
                            "value": "HI"
                          },
                          {
                            "text": "IDAHO",
                            "value": "id"
                          },
                          {
                            "text": "ILLINOIS",
                            "value": "IL"
                          },
                          {
                            "text": "INDIANA",
                            "value": "IN"
                          },
                          {
                            "text": "IOWA",
                            "value": "IA"
                          },
                          {
                            "text": "KANSAS",
                            "value": "KS"
                          },
                          {
                            "text": "KENTUCKY",
                            "value": "KY"
                          },
                          {
                            "text": "LOUISIANA",
                            "value": "LA"
                          },
                          {
                            "text": "MAINE",
                            "value": "ME"
                          },
                          {
                            "text": "MANITOBA",
                            "value": "MB"
                          },
                          {
                            "text": "MARSHALL ISLANDS",
                            "value": "MH"
                          },
                          {
                            "text": "MARYLAND",
                            "value": "MD"
                          },
                          {
                            "text": "MASSACHUSETTS",
                            "value": "MA"
                          },
                          {
                            "text": "MICHIGAN",
                            "value": "MI1"
                          },
                          {
                            "text": "MINNESOTA",
                            "value": "MN"
                          },
                          {
                            "text": "MISSISSIPPI",
                            "value": "MS"
                          },
                          {
                            "text": "MISSOURI",
                            "value": "MO"
                          },
                          {
                            "text": "MONTANA",
                            "value": "MT"
                          },
                          {
                            "text": "NORTH CAROLINA",
                            "value": "NC"
                          },
                          {
                            "text": "NEBRASKA",
                            "value": "NE"
                          },
                          {
                            "text": "NEVADA",
                            "value": "NV"
                          },
                          {
                            "text": "NEW BRUNSWICK",
                            "value": "NB"
                          },
                          {
                            "text": "NEW HAMPSHIRE",
                            "value": "NH"
                          },
                          {
                            "text": "NEW JERSEY",
                            "value": "NJ"
                          },
                          {
                            "text": "NEW MEXICO",
                            "value": "NM"
                          },
                          {
                            "text": "NEW SOUTH WALES",
                            "value": "NS"
                          },
                          {
                            "text": "NEW YORK",
                            "value": "NY"
                          },
                          {
                            "text": "NEWFOUNDLAND AND LABRADOR",
                            "value": "NL1"
                          },
                          {
                            "text": "NORTH DAKOTA",
                            "value": "ND1"
                          },
                          {
                            "text": "NORTHERN MARIANA ISLANDS",
                            "value": "MP"
                          },
                          {
                            "text": "NORTHERN TERRITORY",
                            "value": "NT"
                          },
                          {
                            "text": "NORTHWEST TERRITORIES",
                            "value": "NT1"
                          },
                          {
                            "text": "NOVA SCOTIA",
                            "value": "NS1"
                          },
                          {
                            "text": "NUNAVUT",
                            "value": "NU"
                          },
                          {
                            "text": "OHIO",
                            "value": "OH"
                          },
                          {
                            "text": "OKLAHOMA",
                            "value": "OK"
                          },
                          {
                            "text": "ONTARIO",
                            "value": "ON"
                          },
                          {
                            "text": "OREGON",
                            "value": "OR"
                          },
                          {
                            "text": "PALAU",
                            "value": "PW"
                          },
                          {
                            "text": "PENNSYLVANIA",
                            "value": "PA"
                          },
                          {
                            "text": "PRINCE EDWARD ISLAND",
                            "value": "PE"
                          },
                          {
                            "text": "PUERTO RICO",
                            "value": "PR"
                          },
                          {
                            "text": "QUEBEC",
                            "value": "QC"
                          },
                          {
                            "text": "QUEENSLAND",
                            "value": "QL"
                          },
                          {
                            "text": "RHODE ISLAND",
                            "value": "RI"
                          },
                          {
                            "text": "SASKATCHEWAN",
                            "value": "SK"
                          },
                          {
                            "text": "SOUTH AUSTRALIA",
                            "value": "SA"
                          },
                          {
                            "text": "SOUTH CAROLINA",
                            "value": "SC"
                          },
                          {
                            "text": "SOUTH DAKOTA",
                            "value": "SD"
                          },
                          {
                            "text": "TASMANIA",
                            "value": "TS"
                          },
                          {
                            "text": "TENNESSEE",
                            "value": "TN"
                          },
                          {
                            "text": "TEXAS",
                            "value": "TX"
                          },
                          {
                            "text": "U.S. VIRGIN ISLANDS",
                            "value": "VI"
                          },
                          {
                            "text": "UTAH",
                            "value": "UT"
                          },
                          {
                            "text": "VERMONT",
                            "value": "VT"
                          },
                          {
                            "text": "VICTORIA",
                            "value": "VI1"
                          },
                          {
                            "text": "VIRGINIA",
                            "value": "VA"
                          },
                          {
                            "text": "WASHINGTON",
                            "value": "WA"
                          },
                          {
                            "text": "WEST VIRGINIA",
                            "value": "WV"
                          },
                          {
                            "text": "WESTERN AUSTRALIA",
                            "value": "WA1"
                          },
                          {
                            "text": "WISCONSIN",
                            "value": "WI"
                          },
                          {
                            "text": "WYOMING",
                            "value": "WY"
                          },
                          {
                            "text": "YUKON TERRITORY",
                            "value": "YT"
                          }
                        ]
                  },
                  {
                      name: 'Postal Code',
                      required: false,
                      description: 'Postal Code',
                      displayType: 'TEXT',
                      columnKey: 'ce03ColbPostalCode',
                      width: 187.5,
                      float: 'left',
                      max: 9,
                  },
                  {
                      name: 'Country',
                      required: false,
                      description: 'Country',
                      displayType: 'DROPDOWN',
                      columnKey: 'ce03ColbCountry',
                      width: 187.5,
                      float: 'left',
                      list: [
                          {
                            "text": "United States",
                            "value": "USA"
                          },
                          {
                            "text": "United Kingdom",
                            "value": "GBR"
                          },
                          {
                            "text": "Macau",
                            "value": "MAC"
                          },
                          {
                            "text": "Malaysia",
                            "value": "MYS"
                          },
                          {
                            "text": "Brunei",
                            "value": "BRN"
                          },
                          {
                            "text": "Maldives",
                            "value": "MDV"
                          },
                          {
                            "text": "Sri Lanka",
                            "value": "LKA"
                          },
                          {
                            "text": "Canada",
                            "value": "CAN"
                          },
                          {
                            "text": "Bermuda",
                            "value": "BMU"
                          },
                          {
                            "text": "Singapore",
                            "value": "SGP"
                          },
                          {
                            "text": "India",
                            "value": "IND"
                          },
                          {
                            "text": "Philippines",
                            "value": "PHL"
                          },
                          {
                            "text": "Hong Kong",
                            "value": "HKG"
                          }
                        ]
                  },
                  {
                      name: 'Shipping Company Name',
                      required: false,
                      description: 'Shipping Company Name',
                      displayType: 'DROPDOWN',
                      columnKey: 'ce03ColbShippingCompany',
                      width: 375,
                      float: 'left',
                      list: [
                          {
                              text: 'D-DHL',
                              value: 'D',
                          },
                          {
                              text: 'FE-Fed Ex',
                              value: 'FE',
                          },
                          {
                              text: 'P-Postal Service',
                              value: 'P',
                          },
                          {
                              text: 'U-UPS',
                              value: 'U',
                          },
                          {
                              text: 'O-Other',
                              value: 'O',
                          }
                      ]
                  },
                  {
                      name: 'Tracking Number',
                      required: false,
                      description: 'Tracking Number',
                      displayType: 'TEXT',
                      inputType: 'text',
                      columnKey: 'ce03ColbTrackNo',
                      width: 375,
                      float: 'left',
                      max: 50,
                  },
              ]
          },
          {
              reason: 'CE',
              disputeType: 'Collaboration',
              dataColumnKey: 'CE04',
              dataColumns: [
                  {
                      name: 'Describe what was Downloaded',
                      required: true,
                      description: 'Describe what was Downloaded',
                      displayType: 'TEXT',
                      columnKey: 'cce04DescDownloaded',
                      width: 750,
                      float: 'left',
                      max: 10000
                  },
                  {
                      name: 'Download Date',
                      required: true,
                      description: 'Download Date',
                      displayType: 'SINGLEDATE',
                      columnKey: 'cce04DownloadDate',
                      width: 350,
                      float: 'left',
                      paddingRight:'30px',
                  },
                  {
                      name: 'Download Time',
                      required: false,
                      description: 'Download Time',
                      displayType: 'TIME',
                      columnKey: 'cce04DownloadTime',
                      width: 350,
                      float: 'left',
                  },
                  {
                      name: 'Select at least two options below.',
                      description: 'Select at least two options below.',
                      columnKey: 'cce04SelectOption',
                      displayType: 'LABEL',
                      float: 'left',
                  },
                  {
                      name: `Proof that the merchant's website or application was accessed by the cardholder for merchandise or services on or after the transaction date.`,
                      required: true,
                      attachArray: [{
                          name: 'Describe the Proof',
                          required: true,
                          description: 'Describe the Proof',
                          displayType: 'TEXT',
                          columnKey: 'cce04DescProof',
                          width: 700,
                          float: 'left', 
                          paddingLeft: '44px',   
                          max: 10000                          
                      }],
                      type: '',
                      description: `Proof that the merchant's website or application was accessed by the cardholder for merchandise
                      or services on or after the transaction date.`,
                      displayType: 'CHECKBOX',
                      selected: true,
                      columnKey: 'cce04ProofWebAccess',
                      width:750,
                      float: 'left',
                  },
                  {
                      displayType: 'LINE',
                  },
                  {
                      name: `Evidence that the profile set up by the purchaser on the merchant's website or application was accessed by the purchaser and has been successfully verified by the merchant before the transaction date.`,
                      required: true,
                      attachArray: [{
                          name: 'Describe the Evidence',
                          required: true,
                          description: 'Describe the Evidence',
                          displayType: 'TEXT',
                          columnKey: 'cce04DescEvid',
                          width: 700,
                          float: 'left',  
                          paddingLeft: '44px', 
                          max: 10000                          
                      }],
                      type: '',
                      description: `Evidence that the profile set up by the purchaser on the merchant's website or application was accessed by 
                      the purchaser and has been successfully verified by the merchant before the transaction date.`,
                      displayType: 'CHECKBOX',
                      columnKey: 'cce04EvidenceWebAccess',
                      width:750,
                      float: 'left',
                  },
                  {
                      displayType: 'LINE',
                  },
                  {
                      name: `Evidence that the same device and card used in the disputed transaction were used in a previous transaction that was not disputed.`,
                      required: true,
                      attachArray: [
                          {
                              name: 'Acquirer Reference Number',
                              required: true,
                              description: 'Acquirer Reference Number',
                              displayType: 'TEXT',
                              inputType: 'number',
                              columnKey: 'cce04ARN',
                              width: 700,
                              float: 'left',  
                              paddingLeft: '44px', 
                              max: 24,
                              validate: numeric
                          },
                          {
                              name: 'Transaction Amount',
                              required: true,
                              description: 'Transaction Amount',
                              displayType: 'TEXT',
                              inputType: 'number',
                              columnKey: 'cce04TransacAmount',
                              width: 350,
                              float: 'left', 
                              paddingLeft: '44px',   
                              max: 14,
                              validate: (value) => decimalNumber(value, 13),                          
                          }
                          ,
                          {
                              name: 'Transaction Date',
                              required: true,
                              description: 'Transaction Date',
                              displayType: 'SINGLEDATE',
                              columnKey: 'cce04TranDate',
                              width: 325,
                              float: 'left',  
                              paddingLeft: '44px',                            
                          }
                          ],
                      type: '',
                      description: `Evidence that the same device and card used in the disputed transaction were used in a previous transaction
                      that was not disputed.`,
                      displayType: 'CHECKBOX',
                      columnKey: 'cce04EvidenceSameDevice',
                      width:750,
                      float: 'left',
                  },
                  {
                      displayType: 'LINE',
                  },
                  {
                      name: `Purchaser's IP address and the device geographical location at the date and time of the Transaction.`,
                      required: true,
                      attachArray: [
                          {
                              name: 'Geographical Location',
                              required: true,
                              description: 'Geographical Location',
                              displayType: 'TEXT',
                              columnKey: 'cce04GeoLocation',
                              width: 350,
                              float: 'left',
                              paddingLeft: '44px', 
                              max: 50                           
                          }, {
                              name: 'Purchaser\'s IP address',
                              required: true,
                              description: 'Purchaser\'s IP address',
                              displayType: 'TEXT',
                              columnKey: 'cce04GeoPurcheserIP',
                              width: 350,
                              float: 'left', 
                              paddingLeft: '44px',    
                              max: 50                       
                          }],
                      type: '',
                      description: `Purchaser's IP address and the device geographical location at the date and time of the Transaction.`,
                      displayType: 'CHECKBOX',
                      selected: true,
                      columnKey: 'cce04PurchaserIp',
                      width:750,
                      float: 'left',
                  },
                  {
                      displayType: 'LINE',
                  },
                  {
                      name: `Purchaser's name and email address linked to the customer profile held by the merchant.`,
                      required: true,
                      attachArray: [
                          {
                              name: 'Purchaser\'s Email Address',
                              required: true,
                              description: 'Purchaser\'s Email Address',
                              displayType: 'TEXT',
                              columnKey: 'cce04PurchasrEmail',
                              width: 350,
                              float: 'left',                           
                              paddingLeft: '44px', 
                              max: 50
                          }, {
                              name: 'Purchaser\'s Name',
                              required: true,
                              description: 'Purchaser\'s Name',
                              displayType: 'TEXT',
                              columnKey: 'cce04PurchasrName',
                              width: 350,
                              float: 'left', 
                              paddingLeft: '44px', 
                              max: 50                          
                          }],
                      type: '',
                      description: `Purchaser's name and email address linked to the customer profile held by the merchant.`,
                      displayType: 'CHECKBOX',
                      selected: true,
                      columnKey: 'cce04PurchaserName',
                      width:750,
                      float: 'left',
                  },
                  {
                      displayType: 'LINE',
                  },
                  {
                      name: `Device ID and name of device Ind.`,
                      required: true,
                      attachArray: [
                          {
                              name: 'Device ID',
                              required: true,
                              description: 'Device ID',
                              displayType: 'TEXT',
                              columnKey: 'cce04DevId',
                              width: 350,
                              float: 'left',  
                              paddingLeft: '44px', 
                              max: 50                         
                          }, {
                              name: 'Name of device',
                              required: true,
                              description: 'Name of device',
                              displayType: 'TEXT',
                              columnKey: 'cce04DeviceName',
                              width: 350,
                              float: 'left', 
                              paddingLeft: '44px', 
                              max: 50                          
                          }],
                      type: '',
                      description: `Device ID and name of device Ind.`,
                      displayType: 'CHECKBOX',
                      selected: true,
                      columnKey: 'cce04DeviceIDName',
                      width:750,
                      float: 'left',
                  }
              ]
          },
          {
              reason: 'CP',
              disputeType: 'Allocation',
              dataColumnKey: 'CP01',
              dataColumns: [
                  {
                      name: 'Acquirer Reference Number',
                      required: true,
                      description: 'Acquirer Reference Number',
                      displayType: 'TEXT',
                      inputType: 'number',
                      columnKey: 'aCP01ARN',
                      width: 375,
                      float: 'left',
                      regex: '^[0-9]{23}$|^[0-9]{24}$',
                      value:  autoPopulateDetails?.length == 1 ? autoPopulateDetails[0].arn : undefined,
                  },
                  {
                      name: 'Credit Amount',
                      required: true,
                      description: 'Credit Amount',
                      displayType: 'TEXT',
                      columnKey: 'aCP01CreditAmount',
                      width: 350,
                      value: autoPopulateDetails?.length == 1 ? autoPopulateDetails[0].transactionAmount : undefined,
                      max: 19,
                      validate: (value) => decimalNumber(value, 18),
                  },
                  {
                      name: 'Credit Processed Date (required)',
                      required: true,
                      description: 'Credit Processed Date',
                      displayType: 'SINGLEDATE',
                      columnKey: 'aCP01CreditProceedDate',
                      width: 381,
                      float: 'left',
                      paddingRight:'30px',
                      value: autoPopulateDetails?.length == 1 ? moment(autoPopulateDetails[0].transactionDate) : undefined,
                  },
              ]
          },
          {
            reason: 'CE',
            disputeType: 'Allocation',
            dataColumnKey: 'CE16',
            dataColumns: [
              {
                name: 'Destination Wallet Address (required)',
                required: true,
                description: 'Destination Wallet Address',
                width: 725,
                displayType: 'TEXTAREA',
                columnKey: 'destinationWalletAddress',
                length: 0,
                textAreaMaxLength: 1000,
                height: 150,
                float: 'left',
              },
              {
                name: 'Blockchain Transaction Hash (required)',
                required: true,
                description: 'Blockchain Transaction Hash',
                width: 725,
                displayType: 'TEXTAREA',
                columnKey: 'blockchainTransactionHash',
                length: 0,
                textAreaMaxLength: 1000,
                height: 150,
                float: 'left',
              },
              {
                name: 'Prior approved similar transaction using same cardholder account number',
                required: true,
                description: 'Prior approved similar transaction using same cardholder account number',
                width: 725,
                displayType: 'TEXTAREA',
                columnKey: 'priorSimilarTransaction',
                length: 0,
                textAreaMaxLength: 5000,
                height: 150,
                float: 'left',
              },
             ]
          },
          {
              reason: 'CP',
              disputeType: 'Allocation',
              dataColumnKey: 'CP02',
              dataColumns: [
                  {
                      name: 'Explain why credit/reversal does not apply (required)',
                      required: true,
                      description: 'Explain why credit/reversal does not apply',
                      width: 725,
                      displayType: 'TEXTAREA',
                      columnKey: 'aCP02CRNotApplyReason',
                      length: 0,
                      textAreaMaxLength: 1000,
                      height: 150,
                      float: 'left',
                  },
                  {
                      name: 'Provide ARN and Date of the Credit/Reversal (required)',
                      required: true,
                      description: 'Provide ARN and Date of the Credit/Reversal',
                      width: 725,
                      displayType: 'TEXTAREA',
                      columnKey: 'aCP02ProvideArnCRDate',
                      length: 0,
                      textAreaMaxLength: 1000,
                      height: 150,
                      float: 'left',
                  }
              ]
          },
          {
              reason: 'CP',
              disputeType: 'Collaboration',
              dataColumnKey: 'CP01',
              dataColumns: [
                  {
                      name: 'Credit Amount',
                      required: true,
                      description: 'Credit Amount',
                      displayType: 'TEXT',
                      columnKey: 'cCP01CreditAmount',
                      width: 370,
                      float: 'left',
                      value: autoPopulateDetails?.length == 1 ? autoPopulateDetails[0].transactionAmount : undefined,
                      max: 19,
                      validate: (value) => decimalNumber(value, 18),
                  },
                  {
                      name: 'Credit Date (required)',
                      required: true,
                      description: 'Credit Date',
                      displayType: 'SINGLEDATE',
                      columnKey: 'cCP01CreditDate',
                      width: 370,
                      float: 'left',
                      paddingRight:'12px',
                      value: autoPopulateDetails?.length == 1 ? moment(autoPopulateDetails[0].transactionDate) : undefined,
                  },
                  {
                      name: 'Matching Credit ARN',
                      required: true,
                      description: 'Matching Credit ARN',
                      displayType: 'TEXT',
                      columnKey: 'cCP01MatchCredArn',
                      width: 750,
                      float: 'left',
                      paddingRight: '30px',
                      value:  autoPopulateDetails?.length == 1 ? autoPopulateDetails[0].arn : undefined,
                      max: 24,
                      validate: numeric,
                  },

                  {
                      name: 'Dispute Response Reason Explanation (required)',
                      required: true,
                      description: 'Dispute Response Reason Explanation',
                      width: 725,
                      displayType: 'TEXTAREA',
                      columnKey: 'cCP01DisputeReasonExpl',
                      length: 0,
                      textAreaMaxLength: 1000,
                      height: 150,
                      float: 'left',
                  },
                  {
                    name: 'Dispute Amount',
                    description: 'Dispute Amount',
                    columnKey: 'disputeAmount',
                    inputType: 'number',
                    width: 224,
                    length: 0,
                    float: 'left',
                    displayType: 'AMOUNT',
                  },
                  {
                    name: 'Dispute Currency',
                    description: 'Dispute Currency',
                    columnKey: 'disputeCurrency',
                    currencyWidth:80,
                    length: 0,
                    displayType: 'CURRENCY',
                  },
              ]
          },
          {
              reason: 'CP',
              disputeType: 'Collaboration',
              dataColumnKey: 'CP02',
              dataColumns: [
                  {
                      name: 'Explain why credit/reversal does not apply (required)',
                      required: true,
                      description: 'Explain why credit/reversal does not apply',
                      width: 725,
                      displayType: 'TEXTAREA',
                      columnKey: 'cCP02CRNotApplyReason',
                      length: 0,
                      textAreaMaxLength: 1000,
                      height: 150,
                      float: 'left',
                  },
                  {
                      name: 'Provide ARN and Date of the Credit/Reversal (required)',
                      required: true,
                      description: 'Provide ARN and Date of the Credit/Reversal',
                      width: 725,
                      displayType: 'TEXTAREA',
                      columnKey: 'cCP02ProvideArnCRDate',
                      length: 0,
                      textAreaMaxLength: 1000,
                      height: 150,
                      float: 'left',
                  },
                  {
                      name: 'Dispute Response Reason Explanation (required)',
                      required: true,
                      description: 'Dispute Response Reason Explanation',
                      width: 725,
                      displayType: 'TEXTAREA',
                      columnKey: 'cCP02DisputeReasonDate',
                      length: 0,
                      textAreaMaxLength: 1000,
                      height: 150,
                      float: 'left',
                  }, 
                  {
                    name: 'Dispute Amount',
                    description: 'Dispute Amount',
                    columnKey: 'disputeAmount',
                    inputType: 'number',
                    width: 224,
                    length: 0,
                    float: 'left',
                    displayType: 'AMOUNT',
                  },
                  {
                    name: 'Dispute Currency',
                    description: 'Dispute Currency',
                    columnKey: 'disputeCurrency',
                    currencyWidth:80,
                    length: 0,
                    displayType: 'CURRENCY',
                  },
              ]
          },
          {
            reason: 'ID',
            disputeType: 'Collaboration',
            dataColumnKey: 'IDRC3',
            dataColumns: [
                {
                    name: 'What cancellation date did the cardholder request? (required)',
                    required: true,
                    description: 'What cancellation date did the cardholder request?',
                    displayType: 'SINGLEDATE',
                    columnKey: 'colbCancellationDate',
                    width: '362px',
                    float: 'left',
                    paddingRight:'30px',
                }
            ]
          },
          {
              reason: 'ID',
              disputeType: 'Allocation',
              dataColumnKey: 'IDRA1',
              dataColumns: [
                  {
                      name: 'Check-in Date (required)',
                      required: true,
                      description: 'Check-in Date',
                      width: 362.5,
                      displayType: 'SINGLEDATE',
                      columnKey: 'aIDRA1CheckInDate',
                      float:'left',
                      paddingRight:'30px',
                  },
                  {
                      name: 'Check-out Date (required)',
                      description: 'Check-out Date',
                      required: true,
                      width: 362.5,
                      displayType: 'SINGLEDATE',
                      columnKey: 'aIDRA1CheckOutDate',
                      selectedDate: '',
                      float: 'left',                           
                      paddingRight:'50px',
                  }
              ]
          },
          {
              reason: 'ID',
              disputeType: 'Allocation',
              dataColumnKey: 'IDRA2',
              dataColumns: [
                  {
                      name: 'Embarkation Date (required)',
                      required: true,
                      description: 'Embarkation Date',
                      width: 362.5,
                      displayType: 'SINGLEDATE',
                      columnKey: 'aIDRA2EmbarkDate',
                      float: 'left',
                      paddingRight:'30px',
                  },
                  {
                      name: 'DisEmbarkation Date (required)',
                      description: 'DisEmbarkation Date',
                      required: true,
                      width: 362.5,
                      displayType: 'SINGLEDATE',
                      columnKey: 'aIDRA2DisEmbarkDate',
                      selectedDate: '',
                      float: 'right',                           
                      paddingRight:'50px',
                  }
              ]
          },
          {
              reason: 'ID',
              disputeType: 'Allocation',
              dataColumnKey: 'IDRA3',
              dataColumns: [
                  {
                      name: 'VehicleRentalDate (required)',
                      required: true,
                      description: 'VehicleRentalDate',
                      width: 360,
                      displayType: 'SINGLEDATE',
                      columnKey: 'aIDRA3VRentalDate',
                      float: 'left',
                      paddingRight:'30px',

                  },
                  {
                      name: 'VehicleReturnDate (required)',
                      description: 'VehicleReturnDate',
                      required: true,
                      width: 365,
                      displayType: 'SINGLEDATE',
                      columnKey: 'aIDRA3VRenturnDate',
                      selectedDate: '',
                      float: 'left',                           
                      paddingRight:'0px',
                  }
              ]
          },
          {
              reason: 'ID',
              disputeType: 'Allocation',
              dataColumnKey: 'IDRA4',
              dataColumns: [
                  {
                      name: 'Authorization Date (required)',
                      required: true,
                      description: 'Authorization Date',
                      width: 705,
                      displayType: 'SINGLEDATE',
                      columnKey: 'aIDRA4AuthDate',
                      paddingRight:'30px',

                  },
                  {
                      name: 'Authorized Amount',
                      description: 'Authorized Amount',
                      required: true,
                      width: 675,
                      displayType: 'TEXT',
                      inputType: 'number',
                      columnKey: 'aIDRA4AuthAmount',
                      selectedDate: '',
                  },
                  {
                      name: 'Authorized Code',
                      description: 'Authorized Code',
                      required: true,
                      width: 675,
                      displayType: 'TEXT',
                      columnKey: 'aIDRA4AuthCode',
                      selectedDate: '',
                  }
              ]
          },
          {
              reason: 'ID',
              disputeType: 'Allocation',
              dataColumnKey: 'IDRA5',
              dataColumns: [
                  {
                      name: 'Provide Authorization Date (required)',
                      required: true,
                      description: 'Provide Authorization Date',
                      width: 705,
                      displayType: 'SINGLEDATE',
                      columnKey: 'aIDRA5AuthDate',
                      paddingRight:'30px',
                  }
              ]
          },
          {
              reason: 'ID',
              disputeType: 'Allocation',
              dataColumnKey: 'IDRA6',
              dataColumns: [
                  {
                      name: 'Information of Special Authorization (required)',
                      required: true,
                      description: 'Certification on Special Authorization',
                      displayType: 'TEXTAREA',
                      columnKey: 'aIDRA6CertOnAuth',
                      length: 0,
                      textAreaMaxLength: 1000,
                      width: 725,
                      height: 150,
                      float: 'left',
                      tooltipContent:"Note: If there are multiple authorizations involved, each authorization details to be separated by comma. Provide below information for the authorizations:"+
                      "\n-The date the Transaction was initiated"+
                      "\n-The date the Transaction was completed"+
                      "\n-The dates authorized amounts, and Authorization Codes of the approved Authorizations."
                  },
                  {
                    name: 'What is the correct transaction date?',
                    required: true,
                    description: 'What is the correct transaction date?',
                    width: 310,
                    displayType: 'SINGLECRCTTRSNDATE',
                    columnKey: 'crctTrsctnDateIDRA6',
                    float: 'left',
                    paddingRight:'30px',
                  }
              ]
          },
          {
              reason: 'ID',
              disputeType: 'Allocation',
              dataColumnKey: 'IDRA7',
              dataColumns: [
                  {
                      name: 'Provide brief invalid dispute reason that was not listed (required)',
                      required: true,
                      description: 'Provide brief invalid dispute reason that was not listed',
                      displayType: 'TEXTAREA',
                      columnKey: 'aIDRA7InvalidDispReason',
                      length: 0,
                      textAreaMaxLength: 1000,
                      width: 725,
                      height: 150,
                      float: 'left',
                  },
                  {
                    name: 'What is the correct transaction date?',
                    required: true,
                    description: 'What is the correct transaction date?',
                    width: 310,
                    displayType: 'SINGLECRCTTRSNDATE',
                    columnKey: 'crctTrsctnDateIDRA7',
                    float: 'left',
                    paddingRight:'30px',
                  }
              ]
          },
      ]
  }
}



